import { api } from './client'

export interface ChannelDashboard {
  channel_id: string
  total_subs: number
  total_views: number
  avg_views_per_post: number
  daily_series: { date: string; views: number; subs: number; posts: number }[]
}

export interface SubscriberGrowth {
  date: string
  total_subs: number
  delta: number
}

const dateRange = (days = 30) => {
  const to = new Date().toISOString().slice(0, 10)
  const from = new Date(Date.now() - days * 86400_000).toISOString().slice(0, 10)
  return `from=${from}&to=${to}`
}

export interface PostStats {
  post_id: string
  views: number
  reactions: number
  forwards: number
}

export interface DemographicStats {
  channel_id: string
  countries: Record<string, number>
  languages: Record<string, number>
  platforms: Record<string, number>
}

export const analyticsApi = {
  channelDashboard: (channelId: string): Promise<ChannelDashboard> =>
    api.get(`/v1/analytics/channels/${channelId}/dashboard?${dateRange()}`),

  subscriberGrowth: (channelId: string): Promise<{ growth: SubscriberGrowth[] }> =>
    api.get(`/v1/analytics/channels/${channelId}/growth?${dateRange()}`),

  postStats: (channelId: string): Promise<{ posts: PostStats[] }> =>
    api.get(`/v1/analytics/channels/${channelId}/posts?${dateRange()}`),

  demographics: (channelId: string): Promise<DemographicStats> =>
    api.get(`/v1/analytics/channels/${channelId}/demographics?${dateRange()}`),

  exportCSVUrl: (channelId: string) =>
    `/v1/analytics/channels/${channelId}/export.csv?${dateRange()}`,
}
